import { l } from '../lib/imports'
import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { oxygenModel } from '../models/oxygenModel-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { layers } from '../main/layers-sidecar'

type LineOnUpdate = (
  l: ITooltipLine,
  t: ITileShip | null,
  mc: IMachine | null,
) => boolean

interface ITooltipLine {
  textLabel: IStevieText
  textValue: IStevieText
  // textLabelShadow: IStevieText
  // textValueShadow: IStevieText
  onUpdate: LineOnUpdate
  isValid: boolean
  texts: IStevieText[]
}

interface IData {
  isOpen: boolean
  i: number
  j: number
  // texts: IStevieText[]
  lines: ITooltipLine[]
}
let _data: IData | null = null

export const getData = (): IData => {
  if (!_data) {
    let ctx = scene.getContext()

    let x = 0
    let y = 0

    let lines: ITooltipLine[] = []

    let l = layers.getLayers().uiOnCam

    const addLine = (label: string, onUpdate: LineOnUpdate) => {
      let textLabelShadow = stevieText.create(ctx.font16, 0, 0, l)
      stevieText.setText(textLabelShadow, '' + label)
      stevieText.setTint(textLabelShadow, 0)
      let textLabel = stevieText.create(ctx.font16, 0, 0, l)
      stevieText.setText(textLabel, '' + label)

      let textValueShadow = stevieText.create(ctx.font16, 0, 0, l)
      stevieText.setTint(textValueShadow, 0)
      let textValue = stevieText.create(ctx.font16, 0, 0, l)

      let line: ITooltipLine = {
        textLabel,
        // textLabelShadow,
        textValue,
        // textValueShadow,
        texts: [textLabel, textValue],
        onUpdate,
        isValid: false,
      }
      lines.push(line)
    }

    const setValue = (line: ITooltipLine, val: number | string) => {
      if (typeof val === 'number') {
        val = '' + Math.floor(val)
      }

      stevieText.setText(line.textValue, val)
      //     stevieText.setText(line.textValueShadow, '' + Math.floor(val))
    }

    addLine('Building', (l, t, mc) => {
      if (!t) {
        return false
      }
      let oxyModel = scene.getContext().model
      let oxySpot = oxygenModel.getTile(oxyModel, t.i, t.j)
      if (oxySpot) {
        let v = oxySpot.buildingNum
        if (v <= 0) {
          return false
        }
        setValue(l, v)
        return true
      }
      return false
    })

    addLine('Oxygen', (l, t, mc) => {
      if (!t) {
        return false
      }
      let oxyModel = scene.getContext().model
      let oxySpot = oxygenModel.getTile(oxyModel, t.i, t.j)
      if (oxySpot) {
        setValue(l, oxySpot.o2)
      } else {
        setValue(l, 0)
      }
      return true
    })

    addLine('Power', (l, t, mc) => {
      if (!t || !mc) {
        return false
      }
      setValue(l, mc.batterySupply)
      return true
    })
    addLine('Water', (l, t, mc) => {
      if (!t || !mc) {
        return false
      }
      setValue(l, mc.waterSupply)
      return true
    })
    addLine('Emergency', (l, t, mc) => {
      if (!t || !mc) {
        return false
      }
      setValue(l, mc.emergencySupply)
      return true
    })

    addLine('Machine', (l, t, mc) => {
      if (!t || !mc) {
        return false
      }

      setValue(l, mc.data.buildName)
      return true
    })

    // let texts = []
    // let text = stevieText.create(ctx.font16, x, y, layers.getLayers().uiOnCam)
    // stevieText.setText(text, 'Tooltip!')
    // texts.push(text)

    // y += 24

    // text = stevieText.create(ctx.font16, x, y, layers.getLayers().uiOnCam)
    // stevieText.setText(text, 'Tooltip!')
    // texts.push(text)

    _data = {
      isOpen: true,
      i: -1,
      j: -1,
      lines,
    }
    setOpen(false)
  }
  return _data
}

export const setOpen = (isOpen: boolean) => {
  let data = getData()
  data.isOpen = isOpen
  // stevieText.setBulkVisible(data.texts, isOpen)

  l.forEach(data.lines, (c) => {
    stevieText.setBulkVisible(c.texts, isOpen && c.isValid)
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
  let d = getData()

  let mx = s.input.mousePointer.x
  let my = s.input.mousePointer.y
  let t = tileMapShip.getTileAtMouse(ctx.mapShip, mx, my)

  setOpen(t !== null)

  let mc: IMachine | null = null

  let y = 0
  let x = 40

  if (t) {
    mc = machines.findAtSpot(t.i, t.j, (c) => true)
    x += t.x
    y += t.y
  }

  let valueSpace = 120
  let offset = 2
  l.forEach(d.lines, (c) => {
    c.isValid = c.onUpdate(c, t, mc)

    stevieText.setBulkVisible(c.texts, c.isValid)

    if (!c.isValid) {
    } else {
      stevieText.moveTo(c.textLabel, x, y)
      //  stevieText.moveTo(c.textLabelShadow, x + offset, y + offset)
      stevieText.moveTo(c.textValue, x + valueSpace, y)
      //   stevieText.moveTo(c.textValueShadow, x + valueSpace + offset, y + offset)
      y += 20
    }
  })

  // if (t) {
  //   setOpen(true)
  //   let mc = machines.findAtSpot(t.i, t.j, (c) => true)

  //   // tileMapShip.getTilePos(t)
  //   stevieText.moveTo(d.texts[0], t.x + 40, t.y)
  //   stevieText.moveTo(d.texts[1], t.x + 40, t.y + 24)

  //   if (mc) {
  //     // Machine here
  //     stevieText.setText(d.texts[0], 'Power: ' + mc.batterySupply)
  //   } else {
  //     stevieText.setText(d.texts[0], 'Power: --- ')
  //   }

  //   let oxyModel = scene.getContext().model
  //   let oxySpot = oxygenModel.getTile(oxyModel, t.i, t.j)
  //   if (oxySpot) {
  //     stevieText.setText(d.texts[1], 'O2: ' + Math.floor(oxySpot.o2))
  //   } else {
  //     stevieText.setText(d.texts[1], 'O2: --- ')
  //   }
  // } else {
  //   setOpen(false)
  // }

  let data = getData()
  if (data.isOpen) {
    // let mode = tileMapEditor.getMode()
    // stevieText.setText(data.textMode, mode)
  }
}
